// Product Description JavaScript Functionality

// SIM Compatibility Handler
document.addEventListener('DOMContentLoaded', function() {
  const simData = document.getElementById('sim-compatibility-data');
  if (simData) {
    initSIMCompatibility(JSON.parse(simData.textContent));
  }
  
  function initSIMCompatibility(data) {
    const { variants, messages, defaultVariant } = data;
    const carriers = ['Docomo', 'AU', 'SoftBank', 'Rakuten'];
    
    function updateSIMCompatibility() {
      const currentVariantId = getSelectedVariantId() || defaultVariant;
      const carriersList = document.querySelector('.sim-carriers .carriers-list');
      const explanationDiv = document.querySelector('.sim-carriers .sim-explanation');
      
      if (!carriersList || !currentVariantId || !variants[currentVariantId]) {
        // Show default SIM Free state
        if (carriersList) {
          carriersList.innerHTML = '';
          carriers.forEach(carrier => {
            const badge = document.createElement('span');
            badge.className = 'carrier-badge supported';
            badge.textContent = carrier;
            carriersList.appendChild(badge);
          });
        }
        if (explanationDiv) {
          explanationDiv.style.display = 'none';
        }
        return;
      }
      
      const variant = variants[currentVariantId];
      const blockedCarrier = variant.blockedCarrier;
      
      // Update carrier badges
      carriersList.innerHTML = '';
      carriers.forEach(carrier => {
        const badge = document.createElement('span');
        badge.className = blockedCarrier === carrier ? 'carrier-badge blocked' : 'carrier-badge supported';
        badge.textContent = carrier;
        carriersList.appendChild(badge);
      });
      
      // Update explanation message
      if (blockedCarrier && messages[blockedCarrier]) {
        let targetExplanation = explanationDiv;
        if (!targetExplanation) {
          targetExplanation = document.createElement('div');
          targetExplanation.className = 'sim-explanation';
          carriersList.parentNode.appendChild(targetExplanation);
        }
        targetExplanation.textContent = messages[blockedCarrier];
        targetExplanation.style.display = 'block';
      } else if (explanationDiv) {
        explanationDiv.style.display = 'none';
      }
    }
    
    function getSelectedVariantId() {
      // Primary methods - most reliable
      const radioChecked = document.querySelector('input[name="id"]:checked');
      if (radioChecked) return radioChecked.value;
      
      const select = document.querySelector('select[name="id"]');
      if (select && select.value) return select.value;
      
      // Shopify's data-selected-variant fallback
      const selectedVariantData = document.querySelector('[data-selected-variant]');
      if (selectedVariantData) {
        try {
          const variantData = JSON.parse(selectedVariantData.textContent);
          if (variantData && variantData.id) {
            return variantData.id.toString();
          }
        } catch (e) {
          // Silent fail for parsing errors
        }
      }
      
      return null;
    }

    // Listen for variant changes to update SIM compatibility display
    document.addEventListener('change', function(e) {
      // Handle direct variant ID changes
      if (e.target.name === 'id' || e.target.closest('.product-form__variants')) {
        updateSIMCompatibility();
      }
    });
    
    // Shopify theme event listeners
    ['variant:change', 'variantChange', 'product:variant-change'].forEach(eventName => {
      document.addEventListener(eventName, updateSIMCompatibility);
    });
    
    // Initialize
    updateSIMCompatibility();
  }
});

// iPhone Charger Bundle Functionality
function addChargerToCart(variantId) {
  const button = event.target;
  const originalText = button.textContent;
  
  // Loading state
  button.textContent = '...';
  button.disabled = true;
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        '_bundle_discount': 'iPhone Charger Bundle',
        '_original_price': '3000',
        '_bundle_price': '2500'
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    // Success state
    button.textContent = '✓ Added';
    button.style.backgroundColor = '#28a745';
    
    // Update cart count if exists
    const cartCount = document.querySelector('.cart-count, [data-cart-count]');
    if (cartCount) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          cartCount.textContent = cart.item_count;
        });
    }
    
    // Reset button after delay
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      button.style.backgroundColor = '';
    }, 2000);
  })
  .catch(error => {
    console.error('Error:', error);
    button.textContent = originalText;
    button.disabled = false;
    alert('Error adding to cart');
  });
}

// Make function available globally for onclick handlers
window.addChargerToCart = addChargerToCart; 